import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Resources from './pages/Resources';
import About from './pages/About';
import Industries from './pages/Industries';
import Careers from './pages/Careers';
import Contact from './pages/Contact';
import BlogPost1 from './pages/blogs/blog1';
import BlogPost2 from './pages/blogs/blog2';
import BlogPost3 from './pages/blogs/blog3';
import './styles/globals.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/about" element={<About />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog/reporting-vs-bi-vs-analytics" element={<BlogPost1 />} />
            <Route path="/blog/generative-ai-vs-agentic-ai" element={<BlogPost2 />} />
            <Route path="/blog/bi-consolidation" element={<BlogPost3 />} />
          </Routes>
        </AnimatePresence>
        <Footer />
      </div>
    </Router>
  );
}

export default App;